function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.002 2.232L4 5.697v6.927l6.002-3.465V2.232zM11.001 17.821L5 14.356l6.001-3.465 6 3.465-6 3.465zM12.5 19.197l5.998-3.465v6.93L12.5 26.125v-6.928z",
  fill: "current"
});

function SvgSeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSeat;